import { getService } from 'react-in-angularjs';

import { SolutionType } from '../../../constants/user-info/solutionType';

export const goToSolutionHome = (solution: SolutionType) => {
  const utilService = getService('utilService');

  utilService.goToSolutionHome(solution);
  utilService.applyAsyncFunc();
};
